// extracted by mini-css-extract-plugin
export var accountDescription = "PartnerSignupPage-module__accountDescription___au1t-";
export var accountIcon = "PartnerSignupPage-module__accountIcon___L8-K0";
export var accountSection = "PartnerSignupPage-module__accountSection___jgTdN";
export var accountTitle = "PartnerSignupPage-module__accountTitle___wexT7";
export var actions = "PartnerSignupPage-module__actions___2TIK4";
export var cancelButton = "PartnerSignupPage-module__cancelButton___K3HV+";
export var card = "PartnerSignupPage-module__card___t52LW";
export var checkIcon = "PartnerSignupPage-module__checkIcon___fnGYi";
export var checkItem = "PartnerSignupPage-module__checkItem___b-13c";
export var checkList = "PartnerSignupPage-module__checkList___XR9i0";
export var content = "PartnerSignupPage-module__content___l1+Vk";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var nextStepsSection = "PartnerSignupPage-module__nextStepsSection___wFr-8";
export var pageContainer = "PartnerSignupPage-module__pageContainer___ILLue";
export var partnerAccentGreen = "#228648";
export var partnerAccentGreenDisabled = "rgba(34, 134, 72, 0.4)";
export var partnerAccentGreenPressed = "rgba(34, 134, 72, 0.6)";
export var partnerLinkGlyphHover = "#A8DEB6";
export var partnerLinkGlyphInactive = "rgba(113, 187, 136, 0.4)";
export var partnerLinkGlyphPressed = "rgba(168, 222, 182, 0.8)";
export var partnerLinkGlyphRest = "#71BB88";
export var sectionDescription = "PartnerSignupPage-module__sectionDescription___i3Rk6";
export var sectionHeading = "PartnerSignupPage-module__sectionHeading___V-uHb";
export var sellerIdNotice = "PartnerSignupPage-module__sellerIdNotice___fCG5V";
export var signInButton = "PartnerSignupPage-module__signInButton___6tq-e";
export var signedInMessage = "PartnerSignupPage-module__signedInMessage___68D9u";
export var subtitle = "PartnerSignupPage-module__subtitle___gU8rZ";
export var title = "PartnerSignupPage-module__title___514CR";
export var warningIcon = "PartnerSignupPage-module__warningIcon___l2jbA";
export var warningItem = "PartnerSignupPage-module__warningItem___NwS1B";